import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useNavigate, useLocation } from "react-router-dom";
import MilestoneModal from "@/components/MilestoneModal";
import { celebrate, bigCelebrate } from "@/lib/confetti";

export default function CheckIn() {
  const nav = useNavigate();
  const location = useLocation();
  const focus = location.state?.focus || "";
  const [data, setData] = useState({ earned: "", hours: "", blocker: "", need_help: focus });
  const [milestone, setMilestone] = useState(null);

  const submit = async () => {
    try {
      const { data: r } = await api.post("/checkin", {
        earned: parseFloat(data.earned) || 0,
        hours: parseFloat(data.hours) || 0,
        blocker: data.blocker,
        need_help: data.need_help,
      });
      const hit = (r.new_milestones || [])[0];
      if (hit) {
        bigCelebrate();
        setMilestone(hit);
      } else {
        celebrate();
        toast.success("Check-in logged. Keep going.");
        setTimeout(() => nav("/roadmap"), 400);
      }
    } catch { toast.error("Save failed"); }
  };

  return (
    <div className="max-w-lg mx-auto px-5 pt-6">
      <div className="eyebrow text-[#FD0F10]">WEEKLY CHECK-IN</div>
      <h1 className="font-display text-3xl font-black mt-1">How did this week go?</h1>
      {focus && (
        <div className="mt-3 card-panel p-3 border-[#FD0F10]/40" data-testid="checkin-focus">
          <div className="eyebrow text-[#FD0F10]">FROM YOUR COACH</div>
          <p className="text-sm text-gray-100 mt-1 leading-snug">This week's move: <span className="text-white font-semibold">{focus}</span></p>
        </div>
      )}
      <div className="mt-6 card-panel p-5 space-y-4">
        <Field label="How much did you earn outside your job this week? ($)" testid="ci-earned">
          <input type="number" value={data.earned} onChange={e=>setData(d=>({...d,earned:e.target.value}))} className="w-full bg-[#0B0C0E] border border-[#2A2E39] rounded px-4 py-2.5 outline-none focus:border-[#FD0F10] font-mono-ui" placeholder="0" data-testid="ci-earned"/>
        </Field>
        <Field label="Hours worked on your escape plan" testid="ci-hours">
          <input type="number" value={data.hours} onChange={e=>setData(d=>({...d,hours:e.target.value}))} className="w-full bg-[#0B0C0E] border border-[#2A2E39] rounded px-4 py-2.5 outline-none focus:border-[#FD0F10] font-mono-ui" placeholder="0" data-testid="ci-hours"/>
        </Field>
        <Field label="What stopped you?" testid="ci-blocker">
          <textarea rows={2} value={data.blocker} onChange={e=>setData(d=>({...d,blocker:e.target.value}))} className="w-full bg-[#0B0C0E] border border-[#2A2E39] rounded px-4 py-2.5 outline-none focus:border-[#FD0F10]" placeholder="Time, energy, unsure of next step…" data-testid="ci-blocker"/>
        </Field>
        <Field label="What do you need help with?" testid="ci-help">
          <textarea rows={2} value={data.need_help} onChange={e=>setData(d=>({...d,need_help:e.target.value}))} className="w-full bg-[#0B0C0E] border border-[#2A2E39] rounded px-4 py-2.5 outline-none focus:border-[#FD0F10]" placeholder="Ask your Escape Coach for a plan…" data-testid="ci-help"/>
        </Field>
        <button onClick={submit} className="hero-accent text-white font-bold py-3 rounded w-full" data-testid="ci-submit">Log this week</button>
      </div>
      <MilestoneModal milestone={milestone} onClose={() => { setMilestone(null); nav("/roadmap"); }} />
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <label className="text-xs font-mono-ui uppercase tracking-wider text-gray-400">{label}</label>
      <div className="mt-1">{children}</div>
    </div>
  );
}
